<template>
  <div class="c-registration-step__heading">
    <h3 class="dbc-gt-h3">
      {{ headline }}
    </h3>
    <NuxtLink
      class="dbc-gc-btn dbc-gc-btn--text c-regsitration__change-btn"
      v-if="showChangeButton"
      @click="onChange"
    >
      <span>{{ $t('dbc-button-edit') }}</span>
      <DbcSvg name="dbc-edit" class="c-registration__icon" />
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  headline?: string
  showChangeButton?: boolean
}>()

const emit = defineEmits<{
  (e: 'onChange'): void
}>()

function onChange() {
  emit('onChange')
}
</script>
